<template>
    <el-dialog :title="isEdit ? '编辑风盘' : '添加风盘'" :visible.sync="visible" width="40%" :before-close="handleCloseDialog">
   
        <el-form key="fancoilForm" label-width="108px" :rules="fancoilFormRules" ref="fancoilForm" :model="fancoilForm" class="fancoil-form">
            <el-form-item label="风盘型号" key="1" prop="fancoil_model">
                <el-input v-model="fancoilForm.fancoil_model" :disabled="isEdit" key="fancoil_model"></el-input>
            </el-form-item>
            <el-form-item label="盘管电机功率" key="2" prop="motor_power">
                <el-input v-model.number="fancoilForm.motor_power">
                    <template slot="append">w</template>
                </el-input>
            </el-form-item>
            <el-form-item label="额定风量" key="3" prop="rate_air_amount">
                <el-input v-model.number="fancoilForm.rate_air_amount">
                    <template slot="append">m²</template>  
                </el-input>
            </el-form-item>
            <el-form-item label="高风档换热量" key="4" prop="high_speed_heat">
                <el-input v-model.number="fancoilForm.high_speed_heat">
                    <template slot="append">w</template>
                </el-input>
            </el-form-item>
            <el-form-item label="中风档换热量" key="5" prop="medium_speed_heat">
                <el-input v-model.number="fancoilForm.medium_speed_heat">
                    <template slot="append">w</template>
                </el-input>
            </el-form-item>
            <el-form-item label="低风档换热量" key="6" prop="low_speed_heat">
                <el-input v-model.number="fancoilForm.low_speed_heat">
                    <template slot="append">w</template>
                </el-input>
            </el-form-item>
            <el-form-item label="地暖换热量" key="7" prop="floor_heating">
                <el-input v-model.number="fancoilForm.floor_heating">
                    <template slot="append">w</template>
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitFancoilForm">确定并保存</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import Service from '@/api/Service'
export default {
    name: "FancoilForm",
    props: ["editData", "visible"],
    data() {
        return {
            // 风盘表单
            fancoilForm: {
                fancoil_model: '',
                motor_power: '',
                rate_air_amount: '',
                high_speed_heat:'',
                medium_speed_heat: '',
                low_speed_heat: '',
                floor_heating: '',
                
            },
            // 风盘表单验证
            fancoilFormRules: {
                fancoil_model: [{ required: true, message: '请输入风盘型号', trigger: 'blur' }],
                motor_power: [{ required: true, message: '请输入盘管电机功率', trigger: 'blur' },
                              { type: 'number', message: '请输入数字格式', trigger: 'blur' }],
                rate_air_amount: [{ required: true, message: '请输入额定风量', trigger: 'blur' },
                                  { type: 'number', message: '请输入数字格式', trigger: 'blur' }],
                high_speed_heat: [{ required: true, message: '请输入高风档换热量', trigger: 'blur' },
                                  { type: 'number', message: '请输入数字格式', trigger: 'blur' }],
                medium_speed_heat: [{ required: true, message: '请输入高风档换热量', trigger: 'blur' },
                                    { type: 'number', message: '请输入数字格式', trigger: 'blur' }],
                low_speed_heat: [{ required: true, message: '请输入中风档换热量', trigger: 'blur' },
                                { type: 'number', message: '请输入数字格式', trigger: 'blur' }],
                floor_heating: [{ required: true, message: '请输入低风档换热量', trigger: 'blur' },
                                { type: 'number', message: '请输入数字格式', trigger: 'blur' }],
            },
            
            isEdit: false,
        };
    },
    created() {
        this.handleEditData();
    },
    watch: {
        editData(val) {
            this.handleEditData();
        }
    },
    components: {},
    methods: {
        handleEditData() {
            if(!this.editData.OID) {
                this.isEdit = false;
                this.fancoilForm = {};
                return
            }
            this.isEdit = true;
            // 风盘
            let {
                OID, 
                FancoilModel, 
                FloorHeating, 
                HighSpeedHeat, 
                LowSpeedHeat,
                MediumSpeedHeat,
                MotorPower,
                RateAirAmount
            } = this.editData
            this.fancoilForm.OID = OID;
            this.fancoilForm.fancoil_model = FancoilModel;
            this.fancoilForm.motor_power = MotorPower;
            this.fancoilForm.rate_air_amount = RateAirAmount;
            this.fancoilForm.high_speed_heat = HighSpeedHeat;
            this.fancoilForm.medium_speed_heat = MediumSpeedHeat;
            this.fancoilForm.low_speed_heat = LowSpeedHeat;
            this.fancoilForm.floor_heating = FloorHeating;
            
        },
        handleCloseDialog() {
            this.$refs['fancoilForm'].resetFields();
            this.$emit("handleCloseDialog", false);
        },
        // 保存风盘
        submitFancoilForm() {
			let arr = this.fancoilForm
			for(var i in arr){
				if(arr[i] != '' && !isNaN(arr[i])){
					this.$message({
						type: 'warning',
						message: '请输入数字!'
					});
					return
				}
			}
            this.$refs['fancoilForm'].validate(async (valid) => {
                if(valid){
                    let data;
                    if(this.fancoilForm.OID){
                        // 修改风盘
                        data = await Service.editFancoils(this.fancoilForm)
                    }else{
                        // 添加风盘
                        data = await Service.addFancoils(this.fancoilForm)
                    }
                    if(data) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                        this.$emit("handleCloseDialog", true);
                        this.$refs['fancoilForm'].resetFields();
                    }
                }else{
                    return false
                }
            })
        },
    }
};
</script>

<style scoped>
.fancoil-form {
    padding: 0 24px;
}
</style>
